var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { rest } from 'msw';
import { NODE_BACKUP_PATH } from './node-backup';
import { formatApiPath } from '@/api/utils';
var NODE_BACKUP_URL = formatApiPath(NODE_BACKUP_PATH);
export var defaultMockNodeBackup = {
    enabled: true,
    location: '/mnt/nvram/backup',
    number_of_backups: 1,
    retention_period: 1,
    frequency: 1,
    frequency_unit: 'day(s)',
    start_date: 0,
    location_writable: true,
    available_space: 33209,
    total_space: 41021,
    is_space_enough: true,
    server_time: '2023-07-11T05:53:32+0000',
};
var MockNodeBackupDB = /** @class */ (function () {
    function MockNodeBackupDB() {
        this.nodeBackup = defaultMockNodeBackup;
    }
    MockNodeBackupDB.prototype.readNodeBackup = function () {
        return this.nodeBackup;
    };
    MockNodeBackupDB.prototype.updateNodeBackup = function (nodeBackup) {
        var updatedNodeBackup = __assign(__assign({}, this.nodeBackup), nodeBackup.node_backup);
        this.nodeBackup = updatedNodeBackup;
        return this.nodeBackup;
    };
    return MockNodeBackupDB;
}());
var mockDB = new MockNodeBackupDB();
export var mockGetNodeBackupHandler = rest.get(NODE_BACKUP_URL, function (req, res, ctx) { return res(ctx.status(200), ctx.json({ node_backup: mockDB.readNodeBackup() })); });
export var mockPutNodeBackupHandler = rest.put(NODE_BACKUP_URL, function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, nodeBackup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, req.json()];
            case 1:
                payload = _a.sent();
                nodeBackup = mockDB.updateNodeBackup(payload);
                return [2 /*return*/, res(ctx.status(200), ctx.json({ node_backup: nodeBackup }))];
        }
    });
}); });
